module.exports = __webpack_public_path__ + "static/media/flandria-rhei-ecosystem-interreg-fwv-vertical.a4813439.jpg";